<template>
    <div class="mt-3">
        <apexchart
            type="bar"
            :height="300"
            :width="717.5"
            :options="chartOptions"
            :series="chartData"
        />
    </div>
</template>

<script>
export default {
    name: 'Bar',
    props: {
        chartData: {
            type: Array,
            default: () => [],
        },
        chartLabels: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        chartLabels() {
            const options = { ...this.chartOptions }
            options.labels = this.chartLabels
            this.chartOptions = options
        },
    },
    data: function() {
        return {
            chartOptions: {
                labels: this.chartLabels,
                colors: ['#359C61', '#E7A42F', '#DE5B5B', '#6E6E6E'],
                legend: {
                    show: false,
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '100%',
                        borderRadius: 5,
                        dataLabels: {
                            position: 'center',
                        },
                    },
                },
                responsive: [
                    {
                        breakpoint: 1100,
                        options: {
                            chart: {
                                height: 210,
                                width: 502.25,
                            },
                            dataLabels: {
                                enabled: true,
                                style: {
                                    fontSize: '16px',
                                    colors: ['white'],
                                },
                                formatter: v => (v ? `${v}%` : ''),
                            },
                            yaxis: {
                                labels: {
                                    offsetY: 15,
                                    show: true,
                                    style: {
                                        fontSize: '16px',
                                    },
                                },
                            },
                        },
                    },
                ],
                tooltip: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '24px',
                        colors: ['white'],
                    },
                    formatter: v => (v ? `${v}%` : ''),
                },
                grid: {
                    xaxis: {
                        lines: {
                            show: false,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },
                xaxis: {
                    axisBorder: {
                        show: false,
                    },
                    labels: {
                        show: false,
                    },
                },
                yaxis: {
                    labels: {
                        offsetY: 15,
                        show: true,
                        style: {
                            fontSize: '24px',
                        },
                    },
                },
            },
        }
    },
}
</script>

<style scoped lang="scss"></style>
